// Disable return types for import functions
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// Directly import Home view for faster rendering of first page
import Garde from '@/views/Garde/Garde.vue';
import Dpa from '@/views/Garde/Dpa.vue';
import Login from '@/views/Login.vue';
import LogOut from '@/views/LogOut.vue';
import CguV from '@/views/Footer/Cgu.vue';
import LegalNotice from '@/views/Footer/LegalNotice.vue';
import InfoUtilisateurExterne from '@/views/InfoUtilisateurExterne.vue';
import HistoriqueDpa from '@/views/HistoriqueDpa.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import UpdatePassword from '@/views/UpdatePassword.vue';
import CreateEmail from '@/views/CreateEmail.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import Maintenance from '@/views/Maintenance.vue';
import ErreurGenerale from '@/views/ErreurGenerale.vue';
import NotFound from '@/views/NotFound.vue';
import AuthAmeliPro from '@/components/AuthAmeliPro.vue';
import { Route } from 'vue-router';

/** @see https://router.vuejs.org/fr/essentials/navigation.html for help */
export const routes = [
  {
    path: '/',
    redirect: '/gardes/dpa'
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true // Paramètres disponibles en tant que propriété
  },
  {
    path: '/loginam',
    name: 'loginAm',
    component: AuthAmeliPro,
    meta: { requiresAuth: false },
    props: (route: Route) => ({ psben: route.query.psben })
  },
  {
    path: '/gardes/dpa',
    name: 'dpa',
    component: Dpa,
    meta: { requiresAuth: true, titre: 'Demande de paiement (DPA)' }
  },
  {
    path: '/gardes/recherche',
    name: 'rechercheGarde',
    component: Garde,
    meta: { requiresAuth: true, titre: 'Recherche de gardes' }
  },
  {
    path: '/dpa/historique',
    name: 'historiqueDpa',
    component: HistoriqueDpa,
    meta: { requiresAuth: true, titre: 'Historique des gardes validées' }
  },
  {
    path: '/utilisateurExterne/infos',
    name: 'InfoUtilisateurExterne',
    component: InfoUtilisateurExterne,
    meta: { requiresAuth: false, titre: 'Mon compte / Mes contacts' }
  },

  {
    path: '/logout',
    name: 'logout',
    component: LogOut,
    meta: { requiresAuth: true, titre: 'Déconnexion' }
  },
  {
    path: '/cgu',
    name: 'cgu',
    component: CguV,
    meta: { requiresAuth: false, titre: 'CGU' }
  },
  {
    path: '/legal-notice',
    name: 'legalNotice',
    component: LegalNotice,
    meta: { requiresAuth: false, titre: 'Mentions légales' }
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { requiresAuth: false, titre: 'Réinitialisez votre mot de passe' }
  },
  {
    path: '/update-password',
    name: 'UpdatePassword',
    component: UpdatePassword,
    meta: { requiresAuth: false, titre: 'Modification du mot de passe' }
  },
  {
    path: '/create-email',
    name: 'CreateEmail',
    component: CreateEmail,
    meta: {
      requiresAuth: false,
      titre: 'Adresse e-mail manquante pour l\'utilisation de PEGASE'
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { requiresAuth: false, titre: 'Mot de passe oublié' }
  },
  {
    path: '/erreur-generale',
    name: 'erreurG',
    component: ErreurGenerale
  },
  {
    path: '*', // route inconnue
    name: 'notFound',
    component: NotFound
  }
];
